import { AccountStatus, IAccount } from "../models/account/IAccount";

// Helpers for the haulier pick on the Waste Tracking page. A haulier is an Account with
// isHaulier set; the API's /account/hauliers already drops deleted and archived ones.

export function haulierLabel(account: Pick<IAccount, "name" | "carrierRegistrationNumber">): string {
  return account.carrierRegistrationNumber ? `${account.name} (${account.carrierRegistrationNumber})` : account.name;
}

export interface IHaulierOption {
  value: string;
  label: string;
}

/**
 * Dropdown options for a row: every enabled haulier account by name, plus the row's current
 * haulier even if it has since been disabled or dropped off the list, so a linked row never
 * shows a blank select.
 */
export function haulierOptions(
  accounts: IAccount[] | undefined,
  current?: { haulierAccountId: string | null; haulierName: string | null } | null
): IHaulierOption[] {
  const enabled = (accounts ?? []).filter((a) => a.isHaulier && a.status === AccountStatus.Enabled);
  const options = enabled
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name, "en-gb", { sensitivity: "base" }))
    .map((a) => ({ value: a.id, label: haulierLabel(a) }));

  if (current?.haulierAccountId && !options.some((o) => o.value === current.haulierAccountId)) {
    const known = (accounts ?? []).find((a) => a.id === current.haulierAccountId);
    const label = known ? `${haulierLabel(known)} (disabled)` : `${current.haulierName ?? "Unknown haulier"} (unavailable)`;
    options.unshift({ value: current.haulierAccountId, label });
  }

  return options;
}
